module.exports = __webpack_public_path__ + "img/hr-cargo-wagon-4.9b8e6bd9.png";